export default __webpack_public_path__ + "static/media/stormblade.a2970a6e.png";